import { render } from "./PendingLiquidations.vue?vue&type=template&id=10c82990"
import script from "./PendingLiquidations.vue?vue&type=script&lang=js"
export * from "./PendingLiquidations.vue?vue&type=script&lang=js"

import "./PendingLiquidations.vue?vue&type=style&index=0&id=10c82990&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__